.thumbnail {
  border-radius: var(--border-radius-xs);
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  overflow: hidden;

  &.isRound {
    border-radius: 100%;
  }

  &.isBroken {
    border: 2px dashed #c66;

    &::before {
      font-size: 12px;
      text-align: center;
      font-weight: bold;
      content: "No image";
      text-transform: uppercase;
    }
  }

  & > img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: var(--border-radius-xs);
  }
}
